import { Checkbox } from "@tine/designsystem-ui-react";
import { type ChangeEvent, useContext, useState } from "react";
import type { ValidatedCheckboxProps } from "../../common/types/formTypes";
import { FormContext } from "./FormContext";
import { validateChecked } from "./formUtilities/fieldValidators";
import useFormError from "./formUtilities/useFormErrors";
import useRegisterfield from "./formUtilities/useRegisterField";

const ValidatedCheckbox = ({
   initialValue,
   validator = validateChecked,
   label,
   name,
   required,
   ...checkboxProps
}: ValidatedCheckboxProps) => {
   const [showError, setShowError] = useState(false);
   const { updateFormValues, formValues } = useContext(FormContext);

   const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const { checked } = e.target;
      const value = checked;
      setShowError(false);
      updateFormValues({
         ...formValues[name],
         value,
         error: validator(value, required)
      });
   };

   useRegisterfield(name, initialValue, validator, required);
   useFormError(setShowError, validator as (value: string | boolean, required: boolean) => string, name, required);

   return (
      <Checkbox
         {...checkboxProps}
         label={label}
         isChecked={Boolean(formValues[name]?.value)}
         onChange={handleChange}
         showErrorMessage={showError}
         errorMessage={formValues[name]?.error}
      />
   );
};

export default ValidatedCheckbox;
